import React, { useState, useEffect, useRef } from "react";
import { Divider, Radio, Backdrop, CircularProgress, TablePagination, Grid, Dialog, DialogContentText, DialogActions, DialogTitle, DialogContent, Button, Box, ButtonGroup, Typography, Select, MenuItem, OutlinedInput, InputAdornment, Table, TableHead, TableRow, TableCell, TableBody, IconButton, FormControl, InputLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { StyledDialog } from "../StyledMui";
import useStore from "../Store";
import NewImageModal from "./NewImageDialog";
import AlertDialog from "../ReusableComponents/AlertDialog";
import ApiRequest from "../ApiRequest";

function ManageImageModal() {
  const { setImageModalSubType, imageModalSubType, setSelectedSingleImageData, selectedSingleImageData, disableImageModalType, imageModal, closeModal, getImages, images, loadingModal, openNewImageDialog, imageModalSelectMode, imageModalType, setImageModalType } = useStore((state) => state.header);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setCurrentPage] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [alertDialog, setAlertDialog] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);

  const currentPageImagesRef = useRef([]);
  const filteredImages = images.filter((image) => {
    const matchesType = imageModalType === "all" || image.type === imageModalType;
    const matchesSubType = image.subType === imageModalSubType;
    const searchLowerCase = searchKeyword.toLowerCase();
    const matchesKeyword = searchKeyword === "" || image.name.toLowerCase().includes(searchLowerCase);

    if (imageModalSubType !== "") {
      return matchesType && matchesKeyword && matchesSubType;
    } else {
      return matchesType && matchesKeyword;
    }
  });

  useEffect(() => {
    if (imageModal) {
      getImages();
      setCurrentPage(0);
      setSearchKeyword("");
    }
  }, [imageModal]);

  useEffect(() => {}, [imageModalType]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchKeywordChange = (event) => {
    setSearchKeyword(event.target.value);
    setCurrentPage(0);
  };

  const handleTypeChange = (event) => {
    console.log(event.target.value);
    setImageModalType(event.target.value);
    setCurrentPage(0);
  };

  // 선택된 이미지를 관리하는 함수
  const handleSelectImage = (event, image) => {
    if (event.target.checked) {
      setSelectedImages([...selectedImages, image]);
    } else {
      setSelectedImages(selectedImages.filter((item) => item !== image));
    }

    const currentPageImages = filteredImages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    setSelectAll(currentPageImages.every((img) => selectedImages.includes(img) || img === image));
  };

  const handleSelectAll = (event) => {
    currentPageImagesRef.current = filteredImages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    setSelectAll(event.target.checked && currentPageImagesRef.length > 0);

    if (event.target.checked) {
      setSelectedImages([...selectedImages, ...currentPageImagesRef.current].filter((image, index, self) => self.findIndex((img) => img.code === image.code) === index));
    } else {
      setSelectedImages(selectedImages.filter((image) => !currentPageImagesRef.some((pageImage) => pageImage.code === image.code)));
    }
  };

  const handleRadioChange = (event, rowData) => {
    setSelectedSingleImageData(rowData);
    setOpenDialog(true);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDialog = () => {
    console.log(selectedSingleImageData);
    setOpenDialog(false);
    closeModal("imageModal");
  };
  // 선택된 이미지 삭제
  const deleteImage = (image) => {
    console.log(image);
    setImageToDelete(image);
    setAlertDialog(true);
  };
  const agreeAlertDialog = async () => {
    let endPoint = "/db/deleteData";
    let deleteData = {
      tableName: "image",
      filter: {
        id: imageToDelete.id,
      },
    };
    console.log(deleteData);
    const apiResponse = await ApiRequest.post(endPoint, deleteData);
    console.log(apiResponse);

    setImageToDelete(null);
    setAlertDialog(false);
    getImages();
  };

  return (
    <>
      <StyledDialog open={imageModal} onClose={() => closeModal("imageModal")}>
        <DialogContent>
          <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                {imageModalSelectMode ? <Typography variant="h6">이미지 선택</Typography> : <Typography variant="h6">이미지 관리</Typography>}
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <ButtonGroup variant="contained">
                    {!imageModalSelectMode && (
                      <>
                        <Button onClick={() => openNewImageDialog()}>신규</Button>
                        {/* <Button onClick={() => deleteSelectedImages()}>삭제</Button> */}
                      </>
                    )}
                  </ButtonGroup>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="type">유형 선택</InputLabel>
                  <Select
                    label="유형 선택"
                    value={imageModalType}
                    onChange={handleTypeChange}
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    disabled={disableImageModalType}
                    displayEmpty>
                    <MenuItem value="all">전체</MenuItem>
                    <MenuItem value="alimtalk">알림톡</MenuItem>
                    <MenuItem value="friendtalk">친구톡</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="search">검색</InputLabel>
                    <OutlinedInput
                      id="search"
                      value={searchKeyword}
                      onChange={handleSearchKeywordChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton type="submit" edge="end" aria-label="search">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="검색"
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid container spacing={2}>
                {loadingModal ? (
                  <Backdrop open={true}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : (
                  <></>
                )}
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {/* <TableCell>{!imageModalSelectMode && <input type="checkbox" checked={selectAll && filteredImages.length > 0 && selectedImages.length === currentPageImagesRef.current.length} onChange={handleSelectAll} />}</TableCell> */}
                        <TableCell></TableCell>
                        <TableCell>유형</TableCell>
                        {/* <TableCell>코드</TableCell> */}
                        <TableCell>이름</TableCell>
                        <TableCell>상세유형</TableCell>
                        <TableCell>이미지URL</TableCell>
                        <TableCell>미리보기</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredImages.length > 0 ? (
                        filteredImages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((image) => (
                          <TableRow key={image.code}>
                            <TableCell>{!imageModalSelectMode ? <></> : <Radio checked={selectedSingleImageData && selectedSingleImageData.id === image.id} onChange={(event) => handleRadioChange(event, image)} value={image.code} name="image-radio-button" />}</TableCell>
                            <TableCell>{image.type}</TableCell>
                            {/* <TableCell>{image.code}</TableCell> */}
                            <TableCell>{image.name}</TableCell>
                            <TableCell>{image.subType}</TableCell>
                            <TableCell style={{ maxWidth: 350, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {JSON.parse(image.imageUrl).map((url, index, array) => (
                                <React.Fragment key={index}>
                                  {index !== 0 && <Divider orientation="vertical" flexItem />}
                                  <a href={url} target="_blank" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: "100%" }}>
                                    {url}
                                  </a>
                                </React.Fragment>
                              ))}
                            </TableCell>
                            <TableCell>
                              <img width="300px" height="150px" src={JSON.parse(image.imageUrl)[0]} alt="이미지 미리보기" />
                            </TableCell>
                            <TableCell>
                              {!imageModalSelectMode && (
                                <>
                                  <Button variant="contained" color="error" onClick={() => deleteImage(image)}>
                                    삭제
                                  </Button>
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7}>No images available.</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <TablePagination style={{ overflowY: "hidden" }} rowsPerPageOptions={[]} component="div" count={filteredImages.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
        <DialogActions>
          <IconButton
            autoFocus
            onClick={() => closeModal("imageModal")}
            color="primary"
            style={{
              position: "absolute",
              left: "98%",
              top: "-40px",
              transform: "scale(1.5)",
              // backgroundColor: "lightgray",
              color: "lightgrey",
            }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </StyledDialog>
      <NewImageModal />
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>아래 이미지를 선택하시겠습니까?</DialogTitle>
        <DialogContent style={{ textAlign: "center" }}>
          <img style={{ maxWidth: "300px", height: "auto" }} src={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[0]} alt="선택한 이미지 미리보기" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>취소</Button>
          <Button onClick={handleConfirmDialog} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>
      <AlertDialog open={alertDialog} title="삭제하시겠습니까?" description="삭제된 이미지는 복구할 수 없으나, 삭제된 이미지를 이미 사용하는 템플릿에서는 그대로 사용할 수 있습니다." onClose={() => setAlertDialog(false)} onConfirm={agreeAlertDialog} onCancel={() => setAlertDialog(false)} />
    </>
  );
}

export default ManageImageModal;
